import z from "zod";

export const ResetPasswordEmailSchema = z.object({
  email: z.string().min(1, "Email is required").email("Invalid email address"),
});

export type ResetPasswordEmailFormValues = z.infer<
  typeof ResetPasswordEmailSchema
>;
